module.exports = __webpack_public_path__ + "f96e33adb24e52d1bd77151333075ccf.svg";